import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Globe, Instagram } from "lucide-react";
import { useSettings } from "@/hooks/useSettings";

export const Footer = () => {
  const s = useSettings();
  return (
    <footer className="bg-[#071433] text-white mt-24 grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 grid gap-12 md:grid-cols-12 relative">
        <div className="md:col-span-5">
          <p className="sr-label text-[#9DC1F5]">Let's grow together</p>
          <h3 className="mt-3 text-3xl sm:text-4xl font-extrabold uppercase leading-tight">We're ready <span className="text-[#5AA2FF]">to help you grow.</span></h3>
          <p className="mt-4 text-sm text-slate-300 max-w-md leading-relaxed">Our team is at your service for wholesale pricing, product specifications, samples and distribution opportunities.</p>
          <Link to="/contact" data-testid="footer-contact-cta" className="sr-btn-blue mt-6">Start an inquiry</Link>
        </div>
        <div className="md:col-span-3 text-sm space-y-3">
          <p className="sr-label text-[#9DC1F5]">Navigate</p>
          {[["/catalog", "Product Catalog"], ["/brands", "Brand Collection"], ["/how-to-order", "How to Order"], ["/contact", "Contact & Samples"], ["/admin", "Admin Portal"]].map(([to, l]) => (
            <Link key={to} to={to} className="block text-slate-300 hover:text-white transition-colors">{l}</Link>
          ))}
        </div>
        <div className="md:col-span-4 text-sm space-y-3" data-testid="footer-contact-info">
          <p className="sr-label text-[#9DC1F5]">{s.company_name || "ShelfReady AI LLC"}</p>
          <p className="flex gap-2 text-slate-300"><MapPin size={16} className="mt-0.5 shrink-0 text-[#5AA2FF]" /> {s.address}</p>
          <p className="flex gap-2 text-slate-300"><Mail size={16} className="mt-0.5 shrink-0 text-[#5AA2FF]" /> {s.email}</p>
          <p className="flex gap-2 text-slate-300"><Phone size={16} className="mt-0.5 shrink-0 text-[#5AA2FF]" /> {s.phone}</p>
          <p className="flex gap-2 text-slate-300"><Globe size={16} className="mt-0.5 shrink-0 text-[#5AA2FF]" /> {s.website}</p>
          <p className="flex gap-2 text-slate-300"><Instagram size={16} className="mt-0.5 shrink-0 text-[#5AA2FF]" /> {s.instagram}</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 text-[11px] uppercase tracking-[0.25em] text-slate-400">
          <span>Consumer Brands. Stronger Communities. Brighter Tomorrows.</span>
          <span>Real Brands. More Possibilities.</span>
        </div>
      </div>
    </footer>
  );
};
